export function dateUStoISO(val) {
	const usRegex = /(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)/;
	if (usRegex.test(val)) {
		const m = val.match(usRegex);
		return `${m[3]}-${m[1].padStart(2,'0')}-${m[2].padStart(2,'0')}`;
	} else {
		return false;
	}
}

export function dateISOtoUS(val) {
	if (!val) return false;
	const s = String(val).trim();
	// US format — strip timestamp if present, then handle year
	const usRegex = /^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(\d{2,4})/;
	if (usRegex.test(s)) {
		const m = s.match(usRegex);
		let year = m[3];
		if (year.length === 2) {
			const yr = Number(year);
			year = String(yr >= 50 ? 1900 + yr : 2000 + yr);
		}
		return `${m[1].padStart(2,'0')}/${m[2].padStart(2,'0')}/${year}`;
	}
	// ISO: 2025-12-24 or 2025-12-24 10:59
	const isoRegex = /([12]\d{3})[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])/;
	if (isoRegex.test(s)) {
		const m = s.match(isoRegex);
		return `${m[2]}/${m[3]}/${m[1]}`;
	}
	return false;
}

export function dateToUS(val) {
    const isoRegex = /([1|2]\d\d\d)[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])/;
    const usRegex = /(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]([1|2]\d\d\d)/;
    if (isoRegex.test(val)) {
        const m = val.match(isoRegex);
        return `${m[2]}/${m[3]}/${m[1]}`;
    } else if (usRegex.test(val)) {
        return val;
    } else {
        return false;
    }
}

export function dateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
    return `${year}-${month}-${day}`;
}

/** True when value is the month-to-month marker in any casing (mtm, Mtm, MTM, …). */
export function isMtm(value) {
    return value != null && String(value).trim().toUpperCase() === 'MTM';
}

/** Canonical DB/UI form of the month-to-month marker, or null if not MTM. */
export function normalizeMtm(value) {
    return isMtm(value) ? 'MTM' : null;
}

export function dateToUsString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
    return `${month}/${day}/${year}`;
}

export function stringUStoISO(date) {
    if (date == null || date === '') {
        return date;
    }
    const mtm = normalizeMtm(date);
    if (mtm) {
        return mtm;
    }
    if (!String(date).includes('/')) {
        return date;
    }
    const d = date.split('/');
    if (d.length !== 3 || !d[0] || !d[1] || !d[2]) {
        return null;
    }
    const dateWithoutTime = new Date(`${d[2]}-${d[0].length > 1 ? '' : '0'}${d[0]}-${d[1].length > 1 ? '' : '0'}${d[1]}T00:00:00`);
    if (isNaN(dateWithoutTime.getTime())) {
        return null;
    }
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : `0${dateWithoutTime.getMonth() + 1}`;
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : `0${dateWithoutTime.getDate()}`;
    return `${year}-${month}-${day}`;
}

export function stringISOtoUS(date, withoutZero) {
    if (date == null || date === '') {
        return '';
    }
    const mtm = normalizeMtm(date);
    if (mtm) {
        return mtm;
    }
    const isoDate = toISODateOnly(date);
    if (!isoDate) {
        return '';
    }
    const withoutZeroString = withoutZero ? '' : '0';
    const dateWithoutTime = new Date(`${isoDate}T00:00:00`);
    if (isNaN(dateWithoutTime.getTime())) return '';
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : withoutZeroString + (dateWithoutTime.getMonth() + 1);
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : withoutZeroString + (dateWithoutTime.getDate());
    return `${month}/${day}/${year}`;
}

export function stringUStoUS(date) {
    if (date == null || date === '') {
        return date;
    }
    const mtm = normalizeMtm(date);
    if (mtm) {
        return mtm;
    }
    const d = date.split('/');
    const dateWithoutTime = new Date(`${d[2]}-${d[0].length > 1 ? '' : '0'}${d[0]}-${d[1].length > 1 ? '' : '0'}${d[1]}T00:00:00`);
    const year = dateWithoutTime.getFullYear();
    const month = (dateWithoutTime.getMonth() + 1) >= 10 ? dateWithoutTime.getMonth() + 1 : `0${dateWithoutTime.getMonth() + 1}`;
    const day = dateWithoutTime.getDate() >= 10 ? dateWithoutTime.getDate() : `0${dateWithoutTime.getDate()}`;
    return `${month}/${day}/${year}`;
}

export function dateToTimestamp(date){
    const year = date.getFullYear();
    const month = "0" + (date.getMonth()+1);
    const day = "0" + date.getDate();
    const hours = date.getHours();
    const minutes = "0" + date.getMinutes();
    const seconds = "0" + date.getSeconds();
    return year+"-"+month.substring(month.length-2)+"-"+day.substring(day.length-2)+"T"+hours + ':' + minutes.substring(minutes.length-2) + ':' + seconds.substring(seconds.length-2);
}

export function formatHour(hour){
    if(hour && hour.includes(':')){
        let suffix = 'am';
        let formattedHour = Number(hour.split(':')[0]);
        let minutes = hour.split(':')[1];
        if(formattedHour > 12){
            suffix = 'pm';
            formattedHour = formattedHour - 12;
        }
        formattedHour = `${formattedHour}:${minutes}${suffix}`
        return formattedHour;
    }
    return hour;
}

export function splitTimestamp(timestamp){
    const timestampDate = timestamp ? dateISOtoUS(timestamp.split('T')[0]) : '';
    let timestampHour = timestamp ? formatHour(timestamp.split('T')[1]) : '';
    
    return {timestampDate, timestampHour}
}

// Normalise a stored date value to a plain "YYYY-MM-DD" string. Handles ISO
// values with optional time ("2026-01-28 14:58") and US-format values with
// 2- or 4-digit years and optional time ("6/16/25", "9/20/24 16:51",
// "04/15/2024") that exist in imported rows. Returns null when unparseable.
export function toISODateOnly(value) {
    if (!value) return null;
    const datePart = String(value).trim().split(" ")[0];
    if (datePart.includes("/")) {
      const [m, d, y] = datePart.split("/");
      if (!m || !d || !y) return null;
      let year = Number(y);
      if (isNaN(year) || isNaN(Number(m)) || isNaN(Number(d))) return null;
      if (y.length === 2) year = year >= 50 ? 1900 + year : 2000 + year;
      return `${year}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    return datePart.substring(0, 10);
  }